import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconTaskRating = React.forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <svg
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="yfm-icon yfm-icon-task-rating"
      {...omit(props, ["className"])}
      ref={ref}
    >
      <path
        d="M24.6031 10.5889C25.4931 9.724 25.0042 8.20727 23.7758 8.01925L17.7214 7.1418C17.2325 7.06659 16.8063 6.76575 16.5932 6.31449L13.8732 0.836709C13.3216 -0.278903 11.7297 -0.278903 11.1781 0.836709L8.47058 6.32703C8.25748 6.76575 7.8313 7.07913 7.34243 7.15434L1.28804 8.03178C0.0596117 8.20727 -0.441787 9.72401 0.460731 10.6015L4.84797 14.8759C5.19895 15.2269 5.36191 15.7157 5.27416 16.2046L4.23376 22.2339C4.02066 23.4623 5.31177 24.4025 6.41484 23.8133L11.83 20.9679C12.2687 20.7422 12.7951 20.7422 13.2339 20.9679L18.649 23.8133C19.7521 24.3899 21.0432 23.4623 20.8301 22.2339L19.7897 16.2046C19.7019 15.7157 19.8649 15.2143 20.2158 14.8759L24.6031 10.5889ZM18.8245 13.4218C17.9972 14.2241 17.6211 15.3898 17.8091 16.5305L18.674 21.557L14.1615 19.1879C13.6601 18.9247 13.096 18.7868 12.5319 18.7868C11.9678 18.7868 11.4038 18.9247 10.9024 19.1879L6.38977 21.557L7.25469 16.5305C7.45525 15.3898 7.06666 14.2366 6.25189 13.4218L2.57914 9.86189L7.63074 9.12233C8.77142 8.95937 9.76168 8.23234 10.2756 7.20448L12.5319 2.62921L14.7882 7.20448C15.3021 8.24488 16.2924 8.95937 17.4331 9.12233L22.4847 9.86189L18.8245 13.4218Z"
        fill="#17215C"
      />
      <path
        d="M14.5126 16.781H11.0028C10.4513 16.781 10 16.3297 10 15.7782C10 15.2267 10.4513 14.7754 11.0028 14.7754H14.5126C15.0641 14.7754 15.5154 15.2267 15.5154 15.7782C15.5154 16.3297 15.0641 16.781 14.5126 16.781Z"
        fill="#17215C"
      />
    </svg>
  )
);

IconTaskRating.displayName = "IconTaskRating";

export default IconTaskRating;
